export const licenseConfig = {
  length: 20,
  freeLength: 18,
  state: {
    AVAILABLE: 'AVAILABLE',
    IN_USED: 'IN_USED',
    EXHAUSTED: 'EXHAUSTED',
    SUSPENDED: 'SUSPENDED',
    SUSPENDED_WAIT_FOR_RESUME: 'SUSPENDED_WAIT_FOR_RESUME',
  },
  deviceType: {
    ap: 'DBA',
    switch: 'DBS',
    gateway: 'DBG',
  },
  usedTypes: {
    used: 'Used',
    unused: 'Unused'
  },
  statusTypes: {
    active: 'Active',
    inactive: 'Inactive',
    suspended: 'Suspend'
  },
  termUnit: {
    year: 'YEAR',
    month: 'MONTH',
    day: 'DAY', // for dev only
  },
  terms: [
    { name: '1 Month', days: 30, period: 1, unit: 'MONTH' },
    { name: '1 Year', days: 365, period: 1, unit: 'YEAR' },
    { name: '2 Years', days: 365 * 2, period: 2, unit: 'YEAR' },
    { name: '3 Years', days: 365 * 3, period: 3, unit: 'YEAR' },
    { name: '4 Years', days: 365 * 4, period: 4, unit: 'YEAR' },
    { name: '5 Years', days: 365 * 5, period: 5, unit: 'YEAR' },
    { name: '7 Years', days: 365 * 7, period: 7, unit: 'YEAR' },
  ]
};
